/**
 * useDebouncedValue — micro hook used by the Employees page search box.
 *
 * Page-local rather than `hooks/` so it stays close to its only consumer
 * until a second one shows up. The contract is the trivial textbook
 * shape: returns the latest `value` after `delayMs` of stillness.
 */
import * as React from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = React.useState(value);

  React.useEffect(() => {
    if (delayMs <= 0) {
      setDebounced(value);
      return undefined;
    }
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
